import Lara from '@primeng/themes/lara';
import { provideIcons } from '@ng-icons/core';
import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding, withRouterConfig} from '@angular/router';
import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {HttpLink} from 'apollo-angular/http';
import {MessageService} from 'primeng/api';
import {routes} from './app.routes';
import {DialogService} from 'primeng/dynamicdialog';
import {provideMsal} from "../auth/msal.provider";
import {msalInterceptor} from "../auth/msal.interceptor";
import { ionChevronBack, ionChevronDown, ionExpand, ionFunnel, ionPencil, ionStar, ionTrash } from '@ng-icons/ionicons';
import { providePrimeNG } from 'primeng/config';
import { graphqlProvider } from '../graphql/graphql.provider';
import { definePreset } from '@primeng/themes';
import AuraPlanmeister from '../themes/AuraPlanmeister';


export const appConfig: ApplicationConfig = {
    providers: [
        graphqlProvider,
        provideAnimationsAsync(),
        provideZoneChangeDetection({eventCoalescing: true}),
        provideHttpClient(
            withInterceptors([
                msalInterceptor
            ]),
            withInterceptorsFromDi(),
        ),
        provideRouter(routes,
            withRouterConfig({
                paramsInheritanceStrategy: 'always'
            }),
            withComponentInputBinding(),
        ),
        provideMsal(),
        HttpLink,
        DialogService,
        MessageService,
        provideIcons({
            ionStar,
            ionFunnel,
            ionPencil,
            ionTrash,
            ionChevronBack,
            ionChevronDown
        }),
        providePrimeNG({
            ripple: true,
            theme: {
                preset: AuraPlanmeister,
                options: {
                    darkModeSelector: '.dark',
                    cssLayer: {
                        name: 'primeng'
                    }
                },
            },
        })
    ]
};
